import React from 'react';
import { Link } from "react-router-dom"

export default function SEventList() {

    const events = [
        { id: 1, Name: "MP klasyk" },
        { id: 2, Name: "MP Sztafety" }
    ]

    return (
        <>
            <h1>Event lists</h1>
            <ul>
                {events.map((ev) => (
                    <li ><Link to={`/spikerBoard/${ev.id}`} >{ev.Name}</Link></li>
                ))}
            </ul>
        </>
    )
}